import ExtendCloudModal from "./extend-cloud-modal.component";

export default ExtendCloudModal;
